import { combineReducers } from 'redux';

import announcements from 'js/src/data/announcements';

export const getUpdatesPageRootReducer = () => {
    return combineReducers({
        announcements,
    });
};
